import timeGridRendering from 'src/mixins/timeGrid/timeGridRendering.js'
import momentMixin from 'src/mixins/miscellaneous/momentMixin.js'

export default {
  mixins: [timeGridRendering, momentMixin],

  data () {
    return {
      timeGridSwiperRef: 'timeGridSwiper',
      lastScrollPosition: 0
    }
  },

  methods: {
    keyboardSwipe (event) {
      // Consumers of this mixin can provide a prop to disable keyboard-swipe
      if (this.isKeyboardSwipeDisabled) return

      if (event.keyCode === 37) {
        this.sliderPrev()
      } else if (event.keyCode === 39) {
        this.sliderNext()
      }
    },

    saveScrollPosition () {
      const swiper = this.$refs[this.timeGridSwiperRef]
      const activeSlideTimeContainer = swiper?.querySelector('.swiper-slide-active .time-grid-container')
      this.lastScrollPosition = activeSlideTimeContainer?.scrollTop
    },

    sliderNext () {
      this.saveScrollPosition()
      this.$refs[this.timeGridSwiperRef].swiper.slideNext()
    },

    sliderPrev () {
      this.saveScrollPosition()
      this.$refs[this.timeGridSwiperRef].swiper.slidePrev()
    },

    changePage (direction, routeName, additionalParams = {}) {
      const nextStartDate = this.isDayView
        ? this.addWeekdays(this.startDate, direction, this.daysToShow)
        : this.startDate.clone().startOf(this.isWeekView ? 'isoWeek' : 'month').add(direction, this.viewType)

      return this.updateQueryParams({ startDate: nextStartDate.format('YYYY-MM-DD') }, additionalParams, routeName)
    },

    buttonSwipe (direction) {
      if (direction === '-1') return this.$refs[this.timeGridSwiperRef].sliderPrev()
      return this.$refs[this.timeGridSwiperRef].sliderNext()
    }
  }
}
